document.addEventListener('click', function (e) {
  if (e.target.classList.contains('mute-unmute')) {
    const button = e.target;
    const video = button.nextElementSibling;

    if (video && video.tagName === 'VIDEO') {
      video.volume = 0.5; // Set volume to 50%
      video.muted = !video.muted;
      button.classList.toggle('is-unmuted'); // Toggle class
    }
  }
});
